import React from "react";

const Foto = () => {
  return (
    <div>
      <h1>Fotky</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Foto;